import { render, staticRenderFns } from "./parametri.vue?vue&type=template&id=3080fb4a"
import script from "./parametri.vue?vue&type=script&lang=js"
export * from "./parametri.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports